<irembogov-file-upload-selector
  [loadingFile]="loadingFile"
  [progress]="progress"
  [filePath]="filePath"
  [totalPreviousAttachments]="this.totalPreviousAttachments"
  [totalCertificateAttachments]="this.totalCertificateAttachments"
  [previousAttachments]="this.previousAttachments"
  [certificateAttachments]="this.certificateAttachments"
  [id]="field.key"
  [minimumUploadSize]="field.props['minimumUploadSize']"
  [maximumUploadSize]="field.props['maximumUploadSize']"
  [noFileActionLabel]="noFileActionLabel | translate"
  [dragAndDropText]="noFileSubLabelHtml | translate"
  [maxSizeText]="maxSizeText | translate"
  [formControl]="formControl"
  [allowedFormats]="field.props['allowedFormats']"
  (fileUploadEvent)="onFileUploadEvent($event)"
  (selectFileEvent)="onSelectFile()"
  (selectPreviousAttachmentEvent)="selectPreviousAttachmentEvent($event)"
  (selectCertificateAttachmentEvent)="selectCertificateAttachmentEvent($event)"
  (previousAttachmentEventScroll)="handlePreviousAttachmentPagination($event)"
  (certificateAttachmentEventScroll)="
    handleCertificateAttachmentPagination($event)
  "
  (handleValidationErrors)="handleFileValidationErrors($event)"
  [photoValidationResponse]="photoValidationResponse"
  [validatePhoto]="field.props['validatePhoto']"
  [validatingPhoto]="validatingPhoto"
  [attachmentCode]="field.props['attachmentCode']"
  [allowUploadPreviousFiles]="this.allowUploadPreviousFiles"
  [(duplicateFile)]="duplicateFile"
  [isCertificate]="field.props['isCertificate']"
  [validations]="field.props['validations']"
  [disableDuplicateValidation]="field.props['disableDuplicateValidation']"
  [invalidPhotoDimensions]="invalidPhotoDimensions"
  [photoRequiredDimensions]="photoRequiredDimensions"
  [photoActualDimensions]="photoActualDimensions">
</irembogov-file-upload-selector>
